import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ControlContainer, FormGroupDirective, ReactiveFormsModule } from '@angular/forms';

import { TiimeButtonToggleModule, TiimeFormModule, TiimeIconModule, TiimeTooltipModule } from 'tiime-material';

import { AntiMoneyLaunderingForm } from '@common/forms/anti-money-laundering-form';
import { MissionAcceptanceFormRowComponent } from '@common-shared/components/forms/mission-acceptance-form-row/mission-acceptance-form-row.component';
import { ExternalUrlService } from '@services/external-url.service';
import { SafePipe } from '@shared-pipes/safe/safe.pipe';

// eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
@Component({
  selector: 'app-anti-money-laundering-form',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TiimeButtonToggleModule,
    TiimeFormModule,
    TiimeTooltipModule,
    TiimeIconModule,
    MissionAcceptanceFormRowComponent,
    SafePipe
  ],
  templateUrl: './anti-money-laundering-form.component.html',
  styleUrl: './anti-money-laundering-form.component.scss',
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }]
})
export class AntiMoneyLaunderingFormComponent implements OnInit {
  form: AntiMoneyLaunderingForm;

  constructor(
    private readonly formGroupDirective: FormGroupDirective,
    private readonly externalUrlService: ExternalUrlService
  ) {}

  ngOnInit(): void {
    this.form = this.formGroupDirective.form as AntiMoneyLaunderingForm;
  }

  openGafi(): void {
    this.externalUrlService.openGafi();
  }
}
